import type { MemoryMarkState } from '@wundo/ui';
import { formatShortDay } from './teamFormat.ts';
import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';
import { m } from '@/paraglide/messages.js';

/* The same mark as the circle on top: full with a history, a dashed ring without. */
export function historyMark(colleague: OneOnOneColleagueItem): MemoryMarkState {
  return colleague.history_updated_at ? 'memory' : 'pending';
}

/** "Bijgewerkt op 15 sep", or "Nog geen gespreksinfo". */
export function historyLabel(colleague: OneOnOneColleagueItem): string {
  return colleague.history_updated_at
    ? m.team_history_updated({ date: formatShortDay(colleague.history_updated_at) })
    : m.team_history_none();
}
